<div class="n-breadcrumb d-flex align-items-center justify-content-between">
    <ol class="breadcrumb m-0 bg-transparent p-0">
        <li class="breadcrumb-item"><a href="/#/dealer/home">Home</a></li>
        <li class="breadcrumb-item"><a href="/#/dealer/home">Manage Dealers</a></li>
        <li class="breadcrumb-item active">{{pageTitle}}</li>
    </ol>
</div>

<h3 class="mt-2 font-weight-light">{{pageTitle}}</h3>

<div class="nc-tabs" style="margin: -4px; padding:20px 0;">
    <p-tabView>
        <p-tabPanel leftIcon="icon md-edit" header="Dealer Info">
            <div class="tcard">
                <div class="tcard-body p-4">
                    <div class="col-md-121 ">
                        <form class="editdealer-form" novalidate [formGroup]="editDealerForm">
                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label>Natural Key
                                        <span class="field_req">*</span>
                                    </label>
                                    <input [readonly]="editFlag" type="text" class="form-control"
                                        formControlName="NaturalKey" placeholder="Dealer Code (required)">
                                    <div *ngIf="editDealerForm.controls.NaturalKey.hasError('noValue') ||  editDealerForm.controls.NaturalKey.touched && editDealerForm.controls.NaturalKey.invalid"
                                        class="text-danger">
                                        Please enter Natural Key.
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label>Dealer Name
                                        <span class="field_req">*</span>
                                    </label>
                                    <input type="text" class="form-control" formControlName="DealerName"
                                        placeholder="Dealer Name (required)">
                                    <div *ngIf="editDealerForm.controls.DealerName.hasError('noValue') ||  editDealerForm.controls.DealerName.touched && editDealerForm.controls.DealerName.invalid"
                                        class="text-danger">
                                        Please enter Dealer Name.
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label>Salesforce ID</label>
                                    <input type="text" class="form-control" formControlName="SalesforceID"
                                        placeholder="Salesforce ID">
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label>Address1
                                        <span class="field_req">*</span>
                                    </label>
                                    <input type="text" class="form-control" formControlName="Address1"
                                        placeholder="Address (required)">
                                    <div *ngIf="editDealerForm.controls.Address1.hasError('noValue') ||  editDealerForm.controls.Address1.touched && editDealerForm.controls.Address1.invalid"
                                        class="text-danger">
                                        Please enter Address1.
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label>Address2
                                    </label>
                                    <input type="text" class="form-control" formControlName="Address2"
                                        placeholder="Address (required)">
                                </div>
                                <div class="form-group col-md-3">
                                    <label>City
                                        <span class="field_req">*</span>
                                    </label>
                                    <input type="text" class="form-control" formControlName="City"
                                        placeholder="City (required)">
                                    <div *ngIf="editDealerForm.controls.City.hasError('noValue') ||  editDealerForm.controls.City.touched && editDealerForm.controls.City.invalid"
                                        class="text-danger">
                                        Please enter City.
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label>ZIP
                                        <span class="field_req">*</span>
                                    </label>
                                    <input type="text" class="form-control" formControlName="Zip"
                                        placeholder="ZIP (required)" maxlength="10">
                                    <div *ngIf="editDealerForm.controls.Zip.hasError('noValue') ||  editDealerForm.controls.Zip.touched && editDealerForm.controls.Zip.invalid"
                                        class="text-danger">
                                        Please enter ZIP.
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="class_type">Country
                                        <span class="field_req">*</span>
                                    </label>
                                    <select class="form-control" formControlName="Country"
                                        (change)="onCountryChange($event)">
                                        <option [selected]="editDealerForm.controls.Country.value == null" value="">
                                            Select</option>
                                        <option *ngFor="let country of Countries" [value]="country.CountryCode">
                                            {{country.CountryName}}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="class_type">State/Province
                                        <span class="field_req">*</span>
                                    </label>
                                    <select class="form-control" formControlName="State">
                                        <option [selected]="editDealerForm.controls.State.value == null" value="">Select
                                        </option>
                                        <option *ngFor="let state of States" [value]="state.StateCode">
                                            {{state.StateName}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label>Phone Number
                                        <span class="field_req">*</span>
                                    </label>
                                    <div>
                                        <p-inputMask mask="9999999999" class="mask-control"
                                            formControlName="PhoneNumber"></p-inputMask>
                                    </div>
                                    <div *ngIf="editDealerForm.controls.PhoneNumber.hasError('noValue') ||  editDealerForm.controls.PhoneNumber.touched && editDealerForm.controls.PhoneNumber.invalid"
                                        class="text-danger">
                                        Please enter Phone Number.
                                    </div>
                                    <div *ngIf="phoneNumbervalidationCheck" class="text-danger">
                                        Invalid phone number
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="class_type">Time Zone
                                        <span class="field_req">*</span>
                                    </label>
                                    <select class="form-control" formControlName="TimeZone">
                                        <option [selected]="editDealerForm.controls.TimeZone.value == null" value="">
                                            Select</option>
                                        <option value="CST">CST</option>
                                        <option value="EST">EST</option>
                                        <option value="MST">MST</option>
                                        <option value="PST">PST</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="class_type">OEM
                                        <span class="field_req">*</span>
                                    </label>
                                    <select class="form-control" formControlName="OemCode" *ngIf="!isNonOem">
                                        <option [selected]="editDealerForm.controls.OemCode.value == null" value="">
                                            Select</option>
                                        <option *ngFor="let oem of Oems" [value]="oem.OemCode">
                                            {{oem.OemCode}}</option>
                                    </select>
                                    <div *ngIf="isNonOem">
                                        {{editDealerForm.controls.OemCode.value}}
                                    </div>
                                    <div *ngIf="editDealerForm.controls.OemCode.touched && editDealerForm.controls.OemCode.invalid || editDealerForm.controls.OemCode.hasError('noValue') "
                                        class="text-danger">
                                        Please select OEM.
                                    </div>
                                </div>
                                <!-- <div class="form-group col-md-3">
                                    <label>OpCode Processed Date</label>
                                    <input type="text" class="form-control" formControlName="OpcodeProcessedDate"
                                        placeholder="Opcode Processed Date" disabled>
                                </div> -->
                            </div>
                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label>DPS Id</label>
                                    <input type="text" class="form-control" formControlName="DPSId"
                                        placeholder="DPS  Id" maxlength="10">
                                    <div *ngIf="editDealerForm.controls.DPSId.hasError('noValue') ||  editDealerForm.controls.DPSId.touched && editDealerForm.controls.DPSId.invalid"
                                        class="text-danger">
                                        Please enter dps id.
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label>OneCommand Id</label>
                                    <input type="text" class="form-control" formControlName="OneCommandId"
                                        placeholder="OneCommand Id" maxlength="10">
                                    <div *ngIf="editDealerForm.controls.OneCommandId.hasError('noValue') ||  editDealerForm.controls.OneCommandId.touched && editDealerForm.controls.OneCommandId.invalid"
                                        class="text-danger">
                                        Please enter OneCommand id.
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label>Autoloop Id</label>
                                    <input type="text" class="form-control" formControlName="AutoloopId"
                                        placeholder="AutoLoop Id" maxlength="10">
                                    <div *ngIf="editDealerForm.controls.AutoloopId.hasError('noValue') ||  editDealerForm.controls.AutoloopId.touched && editDealerForm.controls.AutoloopId.invalid"
                                        class="text-danger">
                                        Please enter AutoLoop id.
                                    </div>
                                </div>
                            </div>
                            <div class="text-right btn-footer">
                                <label *ngIf="msgSuccess" style="color: green; margin-right: 15px;">{{Message}} </label>
                                <label *ngIf="msgAllReadyExist" style="color: red; margin-right: 15px;">{{AlreadyExist}}
                                </label>
                                <button type="submit" class="btn btn-light py-2 px-4" [routerLink]="['/dealer/home']">
                                    <i class="icon md-arrow-left mr-2"></i> Cancel</button>
                                <button type="submit" class="btn btn-primary py-2 px-4" (click)="DealerSave()"
                                    [disabled]='!editDealerForm.valid || editDealerForm.controls.Country.value == null || editDealerForm.controls.State.value == null'>
                                    <i class="la la-check mr-2"></i>Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel leftIcon="icon md-view-quilt" header="DMS Enrollments">
            <div class="nc-tabsBody">
                <div style="padding: 20px 0;">
                    <div class="tableinfo">
                        <div class="alert alert-custom alert-secondary d-flex align-items-center flex-wrap"
                            role="alert">
                            <div class="col-6">
                                <div class="text-muted font-weight-bold">Natural Key</div>
                                <div class="text-dark-75 font-weight-bolder d-block font-size-lg">{{NaturalKey}}</div>
                            </div>
                            <div class="col-6">
                                <div class="text-muted font-weight-bold">Dealer Name </div>
                                <div class="text-dark-75 font-weight-bolder d-block font-size-lg">{{dealerName}} </div>
                            </div>
                        </div>
                    </div>

                    <div style="padding-top: 10px;">

                        <div class="table-header d-flex align-items-center justify-content-between mb-2">
                            <div class="table-title mt-1">
                            </div>
                            <div class="table-toolbar" (click)="dealerSource('Add',rowData,'')">
                                <button class="btn btn-primary" type="button"><i
                                        class="la la-plus mr-2"></i>&nbsp;Add</button>
                            </div>
                        </div>
                        <div class="nc-tabs-view nc-table tcard">
                            <div class="tcard-body">
                                <p-table [columns]="dealerSourceCols" [rows]="20" [value]="LstDlrMapping"
                                    [globalFilterFields]="['SourceOfDealer','DealerSource','LastRODate','LastSaleDate','LastSaleFileDate','LastROFileDate','SourceType']"
                                    emptymessage="customMessage" class="mytable" [resizableColumns]="true">
                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th>Actions</th>
                                            <th>Legacy Source</th>
                                            <th>DMS Source</th>
                                            <th>DMS Source Type(s)</th>
                                            <th>Dealer Code</th>
                                            <th>Last RO File Date</th>
                                            <th>Last RO Date</th>
                                            <th>Last Sale File Date</th>
                                            <th>Last Sale Date</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rData let-columns="columns">
                                        <tr>
                                            <td *ngFor="let col of columns">
                                                {{rData[col.field]}}
                                                <div *ngIf="col.field == 'Actions'" class="tcol-actions">
                                                    <span class="action-edit text-primary"
                                                        (click)="dealerSource('Edit',rData,rowData)">
                                                        <i class="flaticon2-writing" title="Edit"></i>
                                                    </span>
                                                    <span
                                                        *ngIf="rData.EffectiveDt == null  || rData.EffectiveDt == '' || rData.EffectiveDt == undefined"
                                                        class="action-delete text-danger"
                                                        (click)="deleteSource(rData,rowData)">
                                                        <i class="flaticon-delete-1" title="Delete"></i>
                                                    </span>
                                                    <span
                                                        *ngIf="rData.EffectiveDt != null && rData.EffectiveDt != '' && rData.EffectiveDt != undefined"
                                                        class="action-delete text-primary"
                                                        title="This data source will be deleted on {{rData.EffectiveDt | date: 'MM-dd-yyyy'}}">
                                                        <i class="icon wb-info-circle text-danger"></i>
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel leftIcon="icon md-accounts-alt" header="Subscription">
            <div class="tab-integration">
                <div class="nc-tabsBody">
                    <div style="padding: 20px 0;">
                        <div class="tableinfo">
                            <div class="alert alert-custom alert-secondary d-flex align-items-center flex-wrap"
                                role="alert">
                                <div class="col-6">
                                    <div class="text-muted font-weight-bold">Natural Key</div>
                                    <div class="text-dark-75 font-weight-bolder d-block font-size-lg">{{NaturalKey}}
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="text-muted font-weight-bold">Dealer Name </div>
                                    <div class="text-dark-75 font-weight-bolder d-block font-size-lg">{{dealerName}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="padding-top: 10px;">

                            <div class="table-header d-flex align-items-center justify-content-between mb-2">
                                <div class="table-title mt-1">
                                </div>
                                <div class="table-toolbar" (click)="newsubscription()">
                                    <button class="btn btn-primary" type="button"><i
                                            class="la la-plus mr-2"></i>&nbsp;Add</button>
                                </div>
                            </div>
                        </div>
                        <div class="nc-tabs-view nc-table">
                            <p-table [columns]="clientSubscriptionCols" [rows]="20" [value]="dealerSubscriptions"
                                [responsive]="true" emptymessage="customMessage" class="mytable"
                                [resizableColumns]="true">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th>Actions</th>
                                        <th>Subscription Name</th>
                                        <th>Client</th>
                                        <th>Source Type</th>
                                        <th>Data Provider</th>
                                        <th>Data Type</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rData let-columns="columns">
                                    <tr>
                                        <td *ngFor="let col of columns">
                                            {{rData[col.field]}}
                                            <div *ngIf="col.field == 'Actions'" class="tcol-actions">

                                                <span class="action-delete text-danger"
                                                    (click)="deleteClientSubscriptionpop(rData)">
                                                    <i class="flaticon-delete-1" title="Delete"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel leftIcon="icon md-file-text" header="Tracking Log">
            <div class="tab-integration">
                <div class="nc-tabsBody" #acti>
                    <div class="tableinfo" style="margin-top: 20px;">
                        <div class="alert alert-custom alert-secondary d-flex align-items-center flex-wrap"
                            role="alert">
                            <div class="col-6">
                                <div class="text-muted font-weight-bold">Natural Key</div>
                                <div class="text-dark-75 font-weight-bolder d-block font-size-lg">{{NaturalKey}}</div>
                            </div>
                            <div class="col-6">
                                <div class="text-muted font-weight-bold">Dealer Name </div>
                                <div class="text-dark-75 font-weight-bolder d-block font-size-lg">{{dealerName}} </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- <div class="col-md-9"></div> -->
                            <div class="col-md-3">
                                <label for="" style="margin-top: 5px;" i18n>Client :</label>
                                <select class="form-control" [(ngModel)]="clientId" (change)="getDealerTrackingLogs()">
                                    <option [selected]="true" value=0>All</option>
                                    <option *ngFor="let client of clients" [value]="client.ClientId"> 
                                        {{client.ClientName}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <label for="" style="margin-top: 5px;" i18n>Date Range Filter :</label>
                                <select class="form-control" [(ngModel)]="dateRangeFilter" (change)="getDealerTrackingLogs()">
                                    <option [selected]="true" value="7">Last 7 days</option>
                                    <option value="30">Last 30 Days </option>
                                    <option value="60">Last 60 Days </option>
                                    <option value="90">Last 90 Days </option>
                                </select>
                            </div>
                        </div>
                        <br>
                    </div>
                    <p-table #dtl [value]="trackingLogs" [responsive]="true" [globalFilterFields]="['CreatedDate','FileName']"
                        emptymessage="customMessage" [paginator]="true" class="mytable" [rows]="20" [resizableColumns]="true">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th width="5%">Date</th>
                                <th width="16%">File Name</th>
                                <th width="7%">File Type</th>
                                <th width="10%">Postage Status</th>
                                <th width="7%">Records Count</th>
                                <th  width="6%">Client</th>
                                <th  width="7%">Data Source</th>
                                <th  width="10%">Schedule Type</th>
                                <th width="3%"><button type="button" class="btn" pButton (click)="exportTrackingLog()" style="float:right"
                                    data-toggle="tooltip" data-placement="top" title="Export to Excel">
                                    <i class="fa fa-file-excel-o" aria-hidden="true" style="font-size: 24px;"></i>
                                </button></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rData>
                            <tr>
                                <td>
                                    {{rData.JobCreatedDate}}
                                </td>
                                <td>
                                    {{rData.FileName}}
                                </td>
                                <td>
                                    {{rData.FileTypeName}}
                                </td>
                                <td *ngIf="rData.StatusCode.toLowerCase() == 'error'">
                                    <span style="color:#eb0e0ead;font-weight: bold;">{{rData.StatusCode}}</span>
                                </td>
                                <td *ngIf="rData.StatusCode.toLowerCase() != 'error'">
                                    {{rData.StatusCode}}
                                </td>
                                <td>
                                    {{rData.FileCount}}
                                </td>
                                <td>
                                    {{rData.ClientName}}
                                </td>
                                <td>
                                    {{rData.SourceName}}
                                </td>
                                <td>
                                    {{rData.ScheduleType}}
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>
<p-dialog header="Add Dealer Source" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true"
    class="modal-lg  tabviewScroll dlr-src-popup">
    <div class="col-md-12">
        <div class="row">
            <div class="col-md-6 mb-3">
                <label>Legacy Dealer</label>
                <select class="form-control" [(ngModel)]="selectedSrcOfDlr"
                    (ngModelChange)="onScourceOfDealerChange($event)" [disabled]="stype == 'Edit'">
                    <option value="-1">Select</option>
                    <option value="Peak">Peak</option>
                    <option value="OC">OC</option>
                    <option value="PCNA">PCNA</option>
                    <option value="DPS">DPS</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
                <label>DMS Data Source</label>
                <select class="form-control" [(ngModel)]="selectedDlrSource"
                    (ngModelChange)="onDealerScourceChange($event)" [disabled]="stype == 'Edit'">
                    <option value="-1">Select</option>
                    <option *ngFor="let dlrsc of dlrSource" [value]="dlrsc.DealerSourceTypeId">
                        {{dlrsc.DealerSource}}
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label>Data Source Types </label>
                <p-multiSelect class="form-multiselect myselect" [(ngModel)]="selectedSrcTypes" [options]="srcTypeList">
                </p-multiSelect>
            </div>
            <div class="col-md-6 mb-3">
                <label>Dealer Code</label>
                <input type="text" class="form-control" [(ngModel)]="dlrCode">
            </div>
        </div>
        <div class="form-group row" style="margin: 0px !important" [hidden]="!role_check">
            <label>Data Standardization Settings:</label>
            <div class="col-md-12 pt-1" id="DPSChkBox" style="padding:0px !important">
                <div class="custom-control custom-checkbox d-inline mr-3">
                    <input type="checkbox" class="custom-control-input" id="NCOA" [(ngModel)]="NcoaFlag" value="NCOA">
                    <label class="custom-control-label" for="NCOA">NCOA</label>
                </div>
                <br>
                <div class="custom-control custom-checkbox d-inline mr-3">
                    <input type="checkbox" class="custom-control-input" id="Vin" [(ngModel)]="VinDecodingFlag"
                        value="Vin">
                    <label class="custom-control-label" for="Vin">Vin Decoding</label>
                </div>
                <br>
                <div class="custom-control custom-checkbox d-inline mr-3">
                    <input type="checkbox" class="custom-control-input" id="Fleet" [(ngModel)]="FleetIdentificationFlag"
                        value="Fleet">
                    <label class="custom-control-label" for="Fleet">Fleet Identification</label>
                </div>
                <br>
                <div class="custom-control custom-checkbox d-inline mr-3">
                    <input type="checkbox" class="custom-control-input" id="VIN_Validation"
                        [(ngModel)]="VinValidationFlag" value="VIN_Validation">
                    <label class="custom-control-label" for="VIN_Validation">VIN Validation</label>
                </div>
                <br>

                <div class="custom-control custom-checkbox d-inline mr-3">
                    <input type="checkbox" class="custom-control-input" id="DNC" [(ngModel)]="DncFlag" value="DNC">
                    <label class="custom-control-label" for="DNC">DNC</label>
                </div>
                <br>

                <div class="custom-control custom-checkbox d-inline mr-3">
                    <input type="checkbox" class="custom-control-input" id="ReturnMailer" [(ngModel)]="ReturnMailerFlag"
                        value="ReturnMailer">
                    <label class="custom-control-label" for="ReturnMailer">Return Mailer</label>
                </div>
                <br>

                <div class="custom-control custom-checkbox d-inline mr-3">
                    <input type="checkbox" class="custom-control-input" id="Active/Inactivecustomer"
                        [(ngModel)]="ActiveInactiveCustomerFlag" value="Active/Inactivecustomer">
                    <label class="custom-control-label" for="Active/Inactivecustomer">Active/Inactive customer</label>
                </div>
                <br>
                <div class="custom-control custom-checkbox d-inline mr-3">
                    <input type="checkbox" class="custom-control-input" id="DinstanceMiles"
                        [(ngModel)]="DistanceMilesFlag" value="DinstanceMiles">
                    <label class="custom-control-label" for="DinstanceMiles">Distance Miles</label>
                </div>
                <br>
                <div class="custom-control custom-checkbox d-inline mr-3">
                    <input type="checkbox" class="custom-control-input" id="NextServiceDue"
                        [(ngModel)]="NextServiceDueFlag" value="NextServiceDue">
                    <label class="custom-control-label" for="NextServiceDue">Next Service Due</label>
                </div>
                <br>
                <div class="custom-control custom-checkbox d-inline mr-3">
                    <input type="checkbox" class="custom-control-input" id="ADMCalculations"
                        [(ngModel)]="AdmCalculationsFlag" value="ADMCalculations">
                    <label class="custom-control-label" for="ADMCalculations">ADM Calculations</label>
                </div>
                <br>
                <div class="custom-control custom-checkbox d-inline mr-3">
                    <input type="checkbox" class="custom-control-input" id="CCPA" [(ngModel)]="CcpaFlag" value="CCPA">
                    <label class="custom-control-label" for="CCPA">CCPA</label>
                </div>
                <br>


            </div>
        </div>

        <div *ngIf="selectedSrcTypes.includes('DECL') == true" class="row">
            <div class="col-md-6 mb-3">
                <input type="checkbox" name="Yellow Flag" [(ngModel)]="isYellow" id="Yellow Flag">
                <label style="padding-left: 5px;">Yellow Flag</label>
            </div>
            <div class="col-md-6 mb-3">
                <input type="checkbox" name="Red Flag" [(ngModel)]="isRed" id="Red Flag" [disabled]="isRed">
                <label style="padding-left: 5px;">Red Flag</label>
            </div>
        </div>
    </div>
    <p-footer class="req-footer">
        <label *ngIf="msgAllReadyExist" style="margin-right: 15px;" class="text-danger">{{AlreadyExist}} </label>
        <button
            [disabled]="selectedSrcTypes?.length==0 || selectedSrcOfDlr == '-1' || selectedDlrSource == '-1' || dlrCode ==''"
            type="submit" class="btn btn-primary py-2 px-4" (click)="SaveSources()" href="javascript:;"><i
                class="la la-check mr-2"></i>Save</button>
    </p-footer>
</p-dialog>

<p-dialog [contentStyle]="{'overflow-y': 'auto', 'overflow-x': 'hidden', 
'max-height': '80vh','min-height':'100px'}" header="Add Subscription" [(visible)]="addsubscription" [responsive]="true"
    showEffect="fade" [modal]="true" class="modal-lg  tabviewScroll" id="subscription-pop">
    <p-tabView class="no-border">        
            <p-table [columns]="dealersubscriptionscols" [rows]="20" [value]="allSubscriptions"
                                [responsive]="true" emptymessage="customMessage" class="mytable"
                                [resizableColumns]="true">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th style="width:0.11%">Include</th>
                                        <th style="width:0.4%">Subscription Name</th>
                                        <th style="width:0.2%">Client</th>
                                        <th style="width:0.2%">Source Type</th>
                                        <th style="width:0.2%">Data Provider</th>
                                        <th style="width:0.2%">Data Type</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rData let-columns="columns">
                                    <tr>
                                        <td *ngFor="let col of columns">
                                            {{rData[col.field]}}
                                            <div *ngIf="col.field == 'Actions'" class="tcol-actions">

                                                
                                                 
                                                    <input (change)="RolecheckValue($event)" id="{{rData.ClientSubscriptionId}}"
                                                     value="{{rData.ClientSubscriptionId}}"  type="checkbox">
                                                    
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
            <!-- <div class="col-md-12 checkbox-custom checkbox-primary ml-2" *ngFor="let alls of allSubscriptions">
                <input class="form-control" type="checkbox" id="{{alls.ClientSubscriptionId}}"
                    (change)="RolecheckValue($event)" class="custom-control-input  form-control"
                    value="{{alls.ClientSubscriptionId}}">
                <label class="custom-control-label"
                    for="{{alls.ClientSubscriptionId}}">{{alls.SubscriptionName}}</label>
            </div> -->
            <div *ngIf="allSubscriptions == 0">
                &nbsp; No subscriptions available
            </div>
        

    </p-tabView>
    <p-footer class="req-footer">
        <div *ngIf="allSubscriptions != 0">
            <button type="submit" (click)="ClientSubscriptionSave()" class="btn btn-primary py-2 px-4"
                href="javascript:;"><i class="la la-check mr-2"> </i>Save</button>
        </div>
    </p-footer>
</p-dialog>
<p-dialog class="confirm-delete-modal required-modal" header="Delete Source" [(visible)]="displayDltDialog"
    [responsive]="true" showEffect="fade" [modal]="true">
    <div class="col-md-12" style="padding-bottom: 20px;">
        <div class="row">
            <div class="form-group col-md-12">
                Are you sure you want to delete this mapping?
            </div>
        </div>
        <table width="100%" cellspadding="0" cellspacing="0">
            <tr>
                <td width="100px">
                    Dealer Code:
                </td>
                <td>
                    <strong style="font-weight: bold">{{srcDlrCode}}</strong>
                </td>
            </tr>
            <tr>
                <td width="130px" style="word-break: break-all;">
                    DMS Data Source:
                </td>
                <td>
                    <strong style="font-weight: bold">{{srcdlrSource}}</strong>
                </td>
            </tr>
            <tr>
                <td width="100px">
                    Data Source Type:
                </td>
                <td>
                    <strong style="font-weight: bold">{{dlrSourceType}}</strong>
                </td>
            </tr>
            <tr>
                <td width="100px">
                    Effective Date:
                </td>
                <td style="padding-bottom: 3px;">
                    <input type="date" class="form-control" [min]='(Currdate | date:"yyyy-MM-dd")'
                        [(ngModel)]="selectedDate" />
                    <!-- <span class="validity"></span>&nbsp;  -->
                </td>
            </tr>
            <tr>
                <td width="100px">
                    Comments:
                </td>
                <td>
                    <textarea class="form-control"
                        style=" min-width:390px; max-width:100%;min-height:100px;height:100%;width:100%;"
                        placeholder="Please enter Comments" [(ngModel)]="deleteComments"></textarea>
                    <span class="text-danger">{{errorMessage}}</span>
                </td>
            </tr>
        </table>
    </div>
    <p-footer class="req-footer">
        <div>
            <button type="submit" class="btn btn-light my-2 py-3 px-5" (click)="No()" href="javascript:;">No</button>
            <button type="submit" class="btn btn-primary my-2 py-3 px-5"
                (click)="Yes(this.selectedDate, this.deleteComments)" href="javascript:;">Yes</button>
        </div>
    </p-footer>
</p-dialog>
<p-dialog class="confirm-delete-modal required-modal" header="Delete Subscription"
    [(visible)]="displayDltSubscriptionDialog" [responsive]="true" showEffect="fade" [modal]="true">
    <div class="col-md-12" style="padding-bottom: 20px;">
        <div class="row">
            <div class="form-group col-md-12">
                Are you sure you want to delete this subscription?
            </div>
        </div>

    </div>
    <p-footer class="req-footer">
        <div>
            <button type="submit" class="btn btn-light my-2 py-3 px-5" (click)="closeDeletePopup()"
                href="javascript:;">No</button>
            <button type="submit" class="btn btn-primary my-2 py-3 px-5" (click)="deleteClientSubscription()"
                href="javascript:;">Yes</button>
        </div>
    </p-footer>
</p-dialog>
<style>
    .table-bordered {
        border: 0px;
    }

    .logtable td,
    .logtable th {
        padding: .75rem;
        vertical-align: top;
        border-top: 1px solid #ffffff;
    }

    .subcounttable td,
    .subcounttable th {
        border-top: 1px solid #dee2e6 !important;
    }

    .dealercount td,
    .dealercount th {
        border-top: 1px solid #dee2e6 !important;
    }

    .logbox {
        border: 2px solid green;
        margin-bottom: 15px;
    }

    .logbox-error {
        border: 2px solid red;
        margin-bottom: 15px;
    }

    .log-body strong {
        background: #FFF;
        padding: 2px 8px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 6px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        position: relative;
    }
    .no-border .p-tabview-panels {
    border: 0;
}
   </style>